export enum Chain {
  Ethereum = "Ethereum",
  Aurora = "Aurora",
  Arbitrum = "Arbitrum",
  Optimism = "Optimism",
  Polygon = "Polygon",
  Fantom = "Fantom",
}
